// eslint-disable-next-line import/prefer-default-export
export const GET_PRICING_PLAN = `https://legacy.tizeti.com/paddycover/payment_init.php`;
